// Một công tắc dạng thẻ: icon + tên + mô tả 1 dòng + trạng thái màu. `big` = công tắc tổng (nổi bật, viền đỏ khi tắt / xanh khi bật).
import { Switch, theme } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function XuFlagTile({ icon, title, desc, checked, onChange, big, onText = "Đang bật", offText = "Đang tắt", disabled }) {
    const { token } = theme.useToken();
    const accent = checked ? token.colorSuccess : big ? token.colorError : token.colorBorderSecondary;
    return (
        <div
            className={`flex items-center gap-3 rounded-xl border ${big ? "p-4 border-2" : "p-3"} h-full`}
            style={{ borderColor: accent, background: big ? (checked ? token.colorSuccessBg : token.colorErrorBg) : token.colorBgContainer }}
        >
            <div className={`rounded-xl flex items-center justify-center shrink-0 ${big ? "w-12 h-12 text-xl" : "w-9 h-9"}`}
                style={{ background: checked ? token.colorSuccessBg : token.colorFillTertiary, color: checked ? token.colorSuccess : token.colorTextTertiary }}>
                <FontAwesomeIcon icon={icon} />
            </div>
            <div className="min-w-0 flex-1">
                <div className={`font-semibold ${big ? "text-base" : "text-sm"}`}>{title}</div>
                <div className="text-xs text-gray-500">{desc}</div>
                <div className="text-xs font-medium mt-0.5" style={{ color: checked ? token.colorSuccess : token.colorTextTertiary }}>● {checked ? onText : offText}</div>
            </div>
            <Switch checked={checked} onChange={onChange} disabled={disabled} />
        </div>
    );
}
